"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMnemonic = void 0;
const faker_1 = require("@faker-js/faker");
const options_1 = __importDefault(require("../../data/options"));
const utils_1 = require("../../utils");
const generateMnemonic = (options) => {
    // Passed Options
    const thresholdMax = options?.thresholdMax || 100;
    const thresholdMin = options?.thresholdMin || 0;
    const deviation = options?.deviation || 10;
    const precision = options?.precision || 0.1;
    const subsystem = options?.subsystem || (0, utils_1.shuffle)(options_1.default.subsystems);
    const childSubsystem = options?.childSubsystem || (0, utils_1.shuffle)(options_1.default.childSubSystems);
    const assemblyDevice = options?.assemblyDevice || (0, utils_1.shuffle)(options_1.default.assemblyDevices);
    const seriousThresholdRange = options?.seriousThresholdRange || 5;
    const cautionThresholdRange = options?.cautionThresholdRange || 10;
    const contactRefId = options?.contactRefId || '';
    //Derived Values
    const id = faker_1.faker.string.uuid();
    const mnemonicId = faker_1.faker.string.alpha({ length: 7, casing: 'upper' });
    const childSubSystemNum = faker_1.faker.number.int({ min: 1, max: 2 });
    const unit = (0, utils_1.shuffle)(options_1.default.units);
    const assembly = unit === 'Volts' ? 'Voltage Monitor' : `Heater Switch Power`;
    const measurement = `${childSubsystem} ${childSubSystemNum} ${assembly}`;
    const currentValue = faker_1.faker.number.float({
        max: thresholdMax + deviation,
        min: thresholdMin - deviation,
        multipleOf: precision,
    });
    const status = (0, utils_1.evaluateStatus)(currentValue, thresholdMin, thresholdMax, seriousThresholdRange, cautionThresholdRange);
    return {
        id,
        type: 'mnemonic',
        mnemonicId,
        status,
        unit,
        thresholdMax,
        thresholdMin,
        currentValue,
        subsystem,
        childSubsystem,
        assemblyDevice,
        measurement,
        contactRefId,
        watched: false,
    };
};
exports.generateMnemonic = generateMnemonic;
